import React from 'react';
import { Box, Typography, Avatar, Button, Grid, styled, useMediaQuery, useTheme } from '@mui/material';

const FriendCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  '&:last-child': {
    borderBottom: 'none',
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
}));

const FriendInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

const FriendAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(6),
  height: theme.spacing(6),
}));

const FriendText = styled(Box)(({ theme }) => ({}));

const FriendName = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
}));

const FriendBio = styled(Typography)(({ theme }) => ({
  variant: 'caption',
  color: theme.palette.text.secondary,
}));

const ViewProfileButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#29BA2E",
  borderRadius: "25px",
  padding: theme.spacing("5px", 2),
  color: theme.palette.common.white,
  fontSize: theme.typography.fontSize * 0.8,
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

const ResponsiveFriendList = ({ friends }) => {
  return (
    <Box sx={{ width: '100%' }}>
      {friends.map((friend, index) => (
        <FriendCard key={index}>
          <FriendInfo>
            <FriendAvatar src={friend.avatarSrc} alt={friend.name} />
            <FriendText>
              <FriendName>{friend.name}</FriendName>
              <FriendBio>{friend.bio}</FriendBio>
            </FriendText>
          </FriendInfo>
          <ViewProfileButton variant="contained" color="primary" size="small">
            View Profile
          </ViewProfileButton>
        </FriendCard>
      ))}
    </Box>
  );
};

const ResponsiveNewFriendsConnection = () => {
  // Replace with your actual friend data
  const friends = [
    { name: 'Jessica Williams', bio: 'Vegetarian, Walk-Outs', avatarSrc: 'https://via.placeholder.com/60/abcdef' },
    { name: 'Jessica Williams', bio: 'Vegetarian, Walk-Outs', avatarSrc: 'https://via.placeholder.com/60/123456' },
    { name: 'Jessica Williams', bio: 'Vegetarian, Walk-Outs', avatarSrc: 'https://via.placeholder.com/60/fedcba' },
    { name: 'Jessica Williams', bio: 'Vegetarian, Walk-Outs', avatarSrc: 'https://via.placeholder.com/60/654321' },
    { name: 'Jessica Williams', bio: 'Vegetarian, Walk-Outs', avatarSrc: 'https://via.placeholder.com/60/aabbcc' },
  ];

  return (
    <Box sx={{ width: '100%', maxWidth: 600, margin: '0 auto', padding: 2 }}>
      <Typography variant="h6" gutterBottom>
        New Friends Connection
      </Typography>
      <ResponsiveFriendList friends={friends} />
    </Box>
  );
};

export default ResponsiveNewFriendsConnection;
